import type { AssessmentQuestion } from '@entities/assessment'

import imgQuestion1 from '../../../../ui/images/questions/math/grade-k6/question-1.png'
import imgQuestion3 from '../../../../ui/images/questions/math/grade-k6/question-3.png'
import imgQuestion5 from '../../../../ui/images/questions/math/grade-k6/question-5.png'
import imgQuestion7 from '../../../../ui/images/questions/math/grade-k6/question-7.png'
import imgQuestion8 from '../../../../ui/images/questions/math/grade-k6/question-8.png'
import imgQuestion9 from '../../../../ui/images/questions/math/grade-k6/question-9.png'
import imgQuestion10 from '../../../../ui/images/questions/math/grade-k6/question-10.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k6_1',
    title: 'A basket is filled with 85 ice lollies. 20 ice lollies are mango-flavored, 16 are mint-flavored, and the rest of them are cocktail-flavored. Find out the ratio of mint to cocktail.',
    topic: 'Ratio and Unit Rate',
    image: imgQuestion1,
    answers: [
      {
        name: 'grade_k6_1_a',
        text: '1:4',
      },
      {
        name: 'grade_k6_1_b',
        text: '1:3',
        correct: true,
      },
      {
        name: 'grade_k6_1_c',
        text: '1:6',
      },
      {
        name: 'grade_k6_1_d',
        text: '2:8',
      },
    ],
  },
  {
    name: 'grade_k6_2',
    title: 'Sam is a taco seller. He prepares 8 tacos in 15 minutes. If his work rate is constant, how many tacos will he prepare in one hour?',
    topic: 'Ratio and Unit Rate',
    answers: [
      {
        name: 'grade_k6_2_a',
        text: '20',
      },
      {
        name: 'grade_k6_2_b',
        text: '15',
      },
      {
        name: 'grade_k6_2_c',
        text: '32',
        correct: true,
      },
      {
        name: 'grade_k6_2_d',
        text: '50',
      },
    ],
  },
  {
    name: 'grade_k6_3',
    title: 'Ron bought 2 1/2 kg of almonds to fill his jars. Each jar is filled with 1/4  kg of almonds. Calculate the number of jars.',
    topic: 'Division of Fractions',
    image: imgQuestion3,
    answers: [
      {
        name: 'grade_k6_3_a',
        text: '5',
      },
      {
        name: 'grade_k6_3_b',
        text: '8',
      },
      {
        name: 'grade_k6_3_c',
        text: '10',
        correct: true,
      },
      {
        name: 'grade_k6_3_d',
        text: '15',
      },
    ],
  },
  {
    name: 'grade_k6_4',
    title: 'Simmel pours 1 4/3 cups of soup into the boiler. Then she pours 2 1/4 cups of more soup after an hour. If one cup holds 20 ml of soup, how much soup is poured into the boiler?',
    topic: 'Rational Numbers',
    answers: [
      {
        name: 'grade_k6_4_a',
        text: '46.3 ml',
      },
      {
        name: 'grade_k6_4_b',
        text: '71.67 ml',
        correct: true,
      },
      {
        name: 'grade_k6_4_c',
        text: '40 ml',
      },
      {
        name: 'grade_k6_4_d',
        text: '65.5 ml',
      },
    ],
  },
  {
    name: 'grade_k6_5',
    title: 'Calculate the value of the expression.',
    topic: 'Expressions and Equation',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k6_5_a',
        text: '288',
        correct: true,
      },
      {
        name: 'grade_k6_5_b',
        text: '250',
      },
      {
        name: 'grade_k6_5_c',
        text: '350',
      },
      {
        name: 'grade_k6_5_d',
        text: '400',
      },
    ],
  },
  {
    name: 'grade_k6_6',
    title: 'Guess the expression that shows 6 more than the product of 8 and x.',
    topic: 'Expressions and Equation',
    answers: [
      {
        name: 'grade_k6_6_a',
        text: '8 + x + 6',
      },
      {
        name: 'grade_k6_6_b',
        text: '6 + 8/x',
      },
      {
        name: 'grade_k6_6_c',
        text: '6 + x/8',
      },
      {
        name: 'grade_k6_6_d',
        text: '8x + 6',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k6_7',
    title: 'Calculate the surface area of the given rectangular prism.',
    topic: 'Surface Area Calculation',
    image: imgQuestion7,
    answers: [
      {
        name: 'grade_k6_7_a',
        text: '258 m²',
        correct: true,
      },
      {
        name: 'grade_k6_7_b',
        text: '356 m²',
      },
      {
        name: 'grade_k6_7_c',
        text: '125 m²',
      },
      {
        name: 'grade_k6_7_d',
        text: '250 m²',
      },
    ],
  },
  {
    name: 'grade_k6_8',
    title: 'Calculate the volume of the given rectangular prism.',
    topic: 'Volume Calculation',
    image: imgQuestion8,
    answers: [
      {
        name: 'grade_k6_8_a',
        text: '2/3 cubic feet',
      },
      {
        name: 'grade_k6_8_b',
        text: '4/6 cubic feet',
        correct: true,
      },
      {
        name: 'grade_k6_8_c',
        text: '1/3 cubic feet',
      },
      {
        name: 'grade_k6_8_d',
        text: '3/6 cubic feet',
      },
    ],
  },
  {
    name: 'grade_k6_9',
    title: 'Ron and Vicky started saving money for a new laptop. They had $25 in January. Find the difference in their savings in December.',
    topic: 'Statistics',
    image: imgQuestion9,
    answers: [
      {
        name: 'grade_k6_9_a',
        text: '$83',
        correct: true,
      },
      {
        name: 'grade_k6_9_b',
        text: '$55',
      },
      {
        name: 'grade_k6_9_c',
        text: '$62',
      },
      {
        name: 'grade_k6_9_d',
        text: '$74',
      },
    ],
  },
  {
    name: 'grade_k6_10',
    title: 'Joseph has 6 tees in his wardrobe. 2 of them are blue, 3 are red, and one is blue. Calculate the probability that Joseph puts on the blue tee.',
    topic: 'Statistics',
    image: imgQuestion10,
    answers: [
      {
        name: 'grade_k6_10_a',
        text: '3',
      },
      {
        name: 'grade_k6_10_b',
        text: '2/3',
      },
      {
        name: 'grade_k6_10_c',
        text: '4/3',
      },
      {
        name: 'grade_k6_10_d',
        text: '1/2',
        correct: true,
      },
    ],
  },
]
